import React from 'react';
import classNames from 'classnames/bind';
import { withRenderFlag } from '@beef/react';

import { pushOpenTariffConnectPopup } from 'utils/ga';
import {
  ChangeTariffBtn,
  ConnectTariffButton,
} from 'pages/ProductCard/components/ConnectButtonsGroup';

import { FloatingWrapper } from '../FloatingConnectWrapper';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

interface IWrapperRenderProps {
  // eslint-disable-next-line react/no-unused-prop-types
  isAvailableForConnect: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  tariffData: {
    marketCode: string;
    pageTitle: string;
    soc: string;
    twoOrderBtnsData?: {
      buySimTabsToDisplay?: Array<unknown>;
      gaEventBuySImMethod?: string;
    };
  };
}

interface IProps {
  connectBtnText: string;
}

const _FloatingBtnsGroup: React.FC<IProps> = ({ connectBtnText }) => (
  <FloatingWrapper
    greyAreaBottomSpace={70}
    render={({ tariffData, isAvailableForConnect }: IWrapperRenderProps) => {
      const onConnectClick = () => {
        // @ts-expect-error TS and JSDoc conflict
        pushOpenTariffConnectPopup({
          isMnp: false,
          tariffName: tariffData.pageTitle,
          marketCode: tariffData.marketCode,
          soc: tariffData.soc,
          method: tariffData.twoOrderBtnsData?.gaEventBuySImMethod || 'Sim',
        });
      };

      return (
        <div className={cx('wrapper')}>
          <ConnectTariffButton
            buttonText={connectBtnText}
            // @ts-expect-error TS and Props Type conflict
            className={cx('connectBtn')}
            isFloatingButton
            newNumber=""
            onClick={onConnectClick}
            popupData={tariffData}
            tabsToDisplay={tariffData.twoOrderBtnsData?.buySimTabsToDisplay}
          />
          {isAvailableForConnect && (
            <div className={cx('changeTariffBtnWrap')}>
              {/* @ts-expect-error TS and Props Type conflict */}
              <ChangeTariffBtn data={tariffData} />
            </div>
          )}
        </div>
      );
    }}
  />
);

export const FloatingBtnsGroup: React.FC<IProps & { shouldRender: boolean }> =
  withRenderFlag(_FloatingBtnsGroup);
